type AnyObj = Record<string, unknown>;

export const getValorTabela = (obj: AnyObj): number | null => {
  // Prioriza val_tabela_liq, se não existir usa val_tabela
  const valor = obj.val_tabela_liq ?? obj.val_tabela;

  // Se não existir nenhum dos dois
  if (valor === undefined || valor === null) return null;

  // Se vier como string, tenta converter
  if (typeof valor === 'string') {
    const n = Number(valor.replace(',', '.'));
    return Number.isFinite(n) ? n : null;
  }

  // Se já for número
  if (typeof valor === 'number') return Number.isFinite(valor) ? valor : null;

  // Qualquer outro tipo
  return null;
};
